<template>
<v-card>
    <v-card-title class="align-baseline">

    </v-card-title>
    <v-data-table :headers="headers" :items="notifications" hide-actions>
        <template slot="items" slot-scope="props">
            <tr>
                <td class="text-xs-center">{{ props.item.id }}</td>
                <td>{{ props.item.message }}</td>
                <td>
                    <v-btn :style="{'background-color': getColor(props.item.type), 'color': 'white', 'width': '100%'}">{{ props.item.type }}</v-btn>
                </td>
                <td class="text-xs-center">
                    <v-icon color="green" large v-if="props.item.active">check_circle</v-icon>
                </td>
                <td>
                    <v-tooltip bottom>
                        <v-btn slot="activator" icon class="mx-0" @click="edit(props.item)">
                            <v-icon color="black">create</v-icon>
                        </v-btn>
                        <span>Edit Notification</span>
                    </v-tooltip>
                </td>
            </tr>
        </template>
        <!-- <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert> -->
    </v-data-table>

    <v-dialog persistent v-model="editNotificationDialog" max-width="700px">
        <notification-edit-form :notificationData="notificationData" :active="editNotificationDialog" @close="editNotificationDialog = false">
        </notification-edit-form>
    </v-dialog>

</v-card>
</template>

<script>
import EditForm from './EditForm'

export default {
    components: {
        NotificationEditForm: EditForm
    },
    data() {
        return {
            headers: [{
                    text: 'ID',
                    align: 'center',
                    width: '5%',
                    value: 'id'
                },
                {
                    text: 'Message',
                    align: 'left',
                    width: '65%',
                    value: 'message'
                },
                {
                    text: 'Type',
                    align: 'center',
                    width: '15%',
                    value: 'type'
                },
                {
                    text: 'Active',
                    align: 'center',
                    width: '10%',
                    value: 'active'
                },
                {
                    text: 'Actions',
                    align: 'left',
                    width: '10%',
                    value: ''
                },
            ],
            editNotificationDialog: false,
            notificationData: {}
        }
    },
    computed: {
        notifications() {
            return this.$store.state.admin.systemNotifications
        }
    },
    methods: {
        edit(notification) {
            this.notificationData = Object.assign({}, notification)
            this.editNotificationDialog = true
        },
        getColor(type) {
            switch (type) {
                case 'success':
                    return '#4caf50'
                    break
                case 'info':
                    return '#2196f3'
                    break
                case 'warning':
                    return '#ffc107'
                    break
                case 'error':
                    return '#ff5252'
                    break
            }
        }
    }
}
</script>
